var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.99007C12.6005 4.99007 13.4973 5.90017 13.4973 7.01503C13.4973 8.12988 12.5996 9.01087 11.5 9.01087C10.4004 9.01087 9.53146 8.12988 9.53146 7.01503C9.53146 5.90017 10.4004 4.99007 11.5 4.99007ZM11.5 0C18.043 0 22.761 6.22233 22.761 6.22233C23.0797 6.6337 23.0797 7.36723 22.761 7.77767C22.761 7.77767 18.042 14 11.5 14C4.95795 14 0.239004 7.77767 0.239004 7.77767C-0.0796681 7.3663 -0.0796681 6.63277 0.239004 6.22233C0.239004 6.22233 4.95795 0 11.5 0ZM11.5 12.0342C14.2217 12.0342 16.4505 9.77445 16.4505 7.01503C16.4505 4.2556 14.2217 1.99584 11.5 1.99584C8.77831 1.99584 6.54946 4.2556 6.54946 7.01503C6.54946 9.77445 8.77831 12.0342 11.5 12.0342Z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.40f2ee6b9c0176fdbab36568d1e740de.svg";
export { ForwardRef as ReactComponent };